import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from "react-i18next";
import Swal from 'sweetalert2';
import axios from "../../common/config/axios";
import moment from "moment";

import { filterErrorHandler } from "../../hoc/Shared/utility";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import TransactionListing from './TransactionListing';
import TransactionDetails from './TransactionDetails';

import * as actions from "../../store/ducks/transaction/actions";
import { getCountryDropdown } from '../../store/ducks/country/actions';
import MemberShow from '../Members/MemberShow/MemberShow';
// import { FaWindows } from 'react-icons/fa';

const initialInputState =
{
    /* form input value */
    order_id: '',
    username: '',
    status: '',
    transaction_type: '',
    transaction_channel: '',
    min_debit: '',
    max_debit: '',
    min_credit: '',
    max_credit: '',
    transaction_date: '',
    start_date: moment().subtract(6, 'days').format('YYYY/MM/DD')+" 12:00:00 AM",
    end_date: moment().format('yyyy/MM/DD')+" 11:59:59 PM",
    exportTransactionType: '',
    country: ''
};

initialInputState.transaction_date = initialInputState.start_date + " - " + initialInputState.end_date;

class Transaction extends Component
{
    /* ============ component lifecycle [START] ============ */
    constructor(props)
    {
        super(props);
        this.state =
        {
            /* component change */
            pageShow: 'listing',

            /* datatables / pagination */
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            totalRecords: 0,
            searchValue: '',

            /* form input value */
            filter: initialInputState,

            /* api result array */
            data: [],
            dropDown:
            {
                status: [],
                transactionType: [],
                transactionChannel: [],
            },

            countryDropDown: [],

            /* transction details parameter */
            detailsParam: {},

            /* skeleton loading */
            loading: true,

            /* redirect member profile */
            redirectParam: {},

            xPosition: 0,
            yPosition: 0
        }
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount()
    {
        // console.log('componentDidMount');
        const listingArr = this.getFilterArray(); // get input params
        this.props.funcGetList(listingArr); // get datatables result
        this.props.funcGetDropDown(); // get filter drop down
        this.props.funcGetCountryDropDown(); // get all countries dropdown
    }

    componentDidUpdate() {
        window.scrollBy(this.state.xPosition,this.state.yPosition);
    }

    shouldComponentUpdate(nextProps, nextState)
    {
        // console.log(nextProps.rs.data.result.row);
        if (nextProps.rs !== this.props.rs && nextProps.rs!==undefined)
        {
            if(nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success')
            {
                this.setState({
                    data: nextProps.rs.data.result.row,
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    loading: false,
                });
            }
            else
            {
                this.setState({
                    activePage: 1,
                    totalRecords: 0,
                    data: [],
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.rs.message);
                });
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown!==undefined)
        {
            if(nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === 'success')
            {
                this.setState({
                    dropDown:
                    {
                        status: nextProps.dropDown.data.status,
                        transactionType: nextProps.dropDown.data.transaction_type,
                        transactionChannel: nextProps.dropDown.data.transaction_channel,
                    }
                });
            }
            else
            {
                this.setState({
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.dropDown.message);
                });
            }
        }

        if(nextProps.country_dropdown !== undefined && nextProps.country_dropdown !== this.props.country_dropdown){
            if(nextProps.country_dropdown.responseCode === 200 && nextProps.country_dropdown.msgType === 'success'){
                this.setState({
                    countryDropDown: nextProps.country_dropdown.data.country_dropdown
                });
            }
            else
            {
                this.setState({
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.country_dropdown.message);
                });
            }
        }

        return true;
    }
    /* ============ component lifecycle [END] ============ */

    /* ============ function [START] ============ */
    onInputChange(event)
    {
        // console.log(event.target.id+' | '+event.target.value);
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;

        if (event.target.id === 'transaction_type') {
            var index = event.nativeEvent.target.selectedIndex;
            newFilter['exportTransactionType'] = event.nativeEvent.target[index].text;
        }
        
        if(event.target.id==='transaction_date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }
        this.setState({
            filter: newFilter
        });
    }

    // searchHandler = () =>
    // {
    //     this.setState({
    //         activePage: 1,
    //         loading: true,
    //         data: [],
    //     }, ()=>
    //     {
    //         const listingArr = this.getFilterArray();
    //         this.props.funcGetList(listingArr);
    //     });
    // }

    clearHandler = () =>
    {
        let newFilter = initialInputState;
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            searchValue: '',
            order: '',            
            filter: newFilter,
            loading: true,
            data: [],
        }, ()=>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    detailsHandler = (e, id) =>
    {
        // console.log('detailsHandler (transaction): ', id);
        e.preventDefault();
        this.setState({
            pageShow: 'details',
            detailsParam :
            {
                id: id
            },
            xPosition: 0,
            yPosition: 0
        });
    }

    refreshHandler = () =>
    {
        this.setState({
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: ''
        }, ()=>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    getFilterArray = () =>
    {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        // listingArr.country_id = this.props.currentUser.country_id;
        Object.keys(this.state.filter).forEach((val) =>
        {
            // listingArr[val] = this.state.filter[val];
            listingArr[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });
        return listingArr;
    }

    changePageHandler = (page,xPosition,yPosition) =>
    {
        this.setState({
            pageShow: page,
            xPosition: page === 'listing' ? xPosition : 0,
            yPosition: page === 'listing' ? yPosition : 0
        });
    }

    exportExcelHandler = () => 
    {
        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => 
            {
                Swal.showLoading();
            }
        });

        const data = {};
        // data.start_date = this.state.filter.start_date ? moment(this.state.filter.start_date).format("YYYY-MM-DD HH:mm:ss") : '';
        // data.end_date = this.state.filter.end_date ? moment(this.state.filter.end_date).format("YYYY-MM-DD HH:mm:ss") : '';
        data.transaction_date =  this.state.filter.transaction_date;
        data.username = this.state.filter.username;
        data.order_id = this.state.filter.order_id;
        data.status = this.state.filter.status;
        data.transaction_channel = this.state.filter.transaction_channel;
        data.transaction_type = this.state.filter.transaction_type;
        data.min_debit = this.state.filter.min_debit;
        data.max_debit = this.state.filter.max_debit;
        data.min_credit = this.state.filter.min_credit;
        data.max_credit = this.state.filter.max_credit;
        data.country = this.state.filter.country;
        // data.order = JSON.stringify(this.state.order);

        axios
            .get("transaction/export_excel", {
                params: data,
                responseType: "blob",
            })
            .then((res) => {
                const currentDate = new Date();
                const timestamp = moment(currentDate).format("YYMMDD HHmmss");
                const merchantSlug = process.env.REACT_APP_MERCHANT_SLUG;
                let fileName = `${merchantSlug} Report - Transaction ${this.state.filter.exportTransactionType} ${timestamp}`;
                const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
                const aElement = document.createElement("a");
                const href = window.URL.createObjectURL(blob);
                aElement.href = href;
                aElement.download = fileName;
                document.body.appendChild(aElement);
                aElement.click();
                document.body.removeChild(aElement);
                window.URL.revokeObjectURL(href);
                Swal.close();
            })
            .catch((err) => {
                console.log("Excel - Transaction Error", err);
            });
    };
    /* ============ function [END] ============ */

    /* ============ datatables function [START] ============ */
    datatablesChangeHandler = (val, act) =>
    {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        this.setState({
            [act]: (act==='searchValue') ? val.target.value : val,
            loading: true,
            data: [],
        }, () =>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    onSort = (field, order) =>
    {
        const orderArry = [{}];
        let orderSequence = (order === "asc") ? true : false ;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
        }, () =>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }
    /* ============ datatables function [END] ============ */

    // redirect to member profile
    redirectHandler = (e, id, name)=>{
        const filteredRows = this.props.rs.data.result.row.filter(row => row.username === name);
        e.preventDefault();
        this.setState({
            pageShow: "redirect",
            redirectParam: {
                id: id,
                name: name,
                shortcode: filteredRows[0]['shortcode'],
            },
            xPosition: 0,
            yPosition: 0
        });
    }

    render()
    {
        return (
            <Auxiliary>
                {this.state.pageShow==='listing' &&
                    <TransactionListing
                        /* filter input */
                        filter={this.state.filter}

                        /* setstate function */
                        changePageHandler={(page) => this.changePageHandler(page)}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        detailsHandler={(event, id) => this.detailsHandler(event, id)}
                        onInputChange={(event) => this.onInputChange(event)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        onSort={(field, order) => this.onSort(field, order)}
                        redirectHandler={(event,id,name)=>this.redirectHandler(event,id,name)}
                        exportExcelHandler={() => this.exportExcelHandler()}

                        /* datatables data */
                        data={this.state.data}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        searchValue={this.state.searchValue}

                        /* filter drop down */
                        ddStatus={this.state.dropDown.status}
                        ddTransactionType={this.state.dropDown.transactionType}
                        ddTransactionChannel={this.state.dropDown.transactionChannel}
                        ddCountry={this.state.countryDropDown}

                        /* skeleton loading */
                        loading={this.state.loading}

                        /* user session */
                        // currentUser={this.props.currentUser}
                        permission={this.props.currentUser.permission ?? []}
                    />
                }

                {this.state.pageShow==='details' &&
                    <TransactionDetails
                        detailsParam={this.state.detailsParam}
                        changePageHandler={(page,xPosition,yPosition) => this.changePageHandler(page,xPosition,yPosition)}
                        returnPage='listing'
                        xPosition={window.pageXOffset}
                        yPosition={window.pageYOffset}
                    />
                }

                {this.state.pageShow==='redirect' &&
                    <MemberShow 
                        memberShowId={this.state.redirectParam.id}
                        memberShowUsername={this.state.redirectParam.name}
                        memberShowCountry= {this.state.redirectParam.shortcode}
                        changePageHandler={(page,xPosition,yPosition) => this.changePageHandler(page,xPosition,yPosition)}
                        permission={this.props.currentUser.permission ?? []}
                        memberShowCount={0}
                        xPosition={window.pageXOffset}
                        yPosition={window.pageYOffset}
                    />
                }
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state =>
{
    return {
        rs: state.transaction.rs,
        dropDown: state.transaction.dropDown,
        currentUser: state.currentUser.data,
        country_dropdown: state.country.country_dropdown
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch =>
{
    return {
        funcGetList: (filter) => dispatch(actions.getList(filter)),
        funcGetDropDown: () => dispatch(actions.getDropDown()),
        funcGetCountryDropDown: () => dispatch(getCountryDropdown())
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Transaction));
